"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdLoading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TpdLoading_style_1 = require("./TpdLoading.style");
const TpdLoading = (props) => {
    const currentTimeout = (0, react_1.useRef)(null);
    const [isDelayedRunning, setDelayedRunning] = (0, react_1.useState)(false);
    const [isSvil, setSvil] = (0, react_1.useState)(false);
    const isLoadingCalled = (0, react_1.useRef)(false);
    // on props.isLoading change
    (0, react_1.useEffect)(() => {
        isLoadingCalled.current = true;
        if (!props.isLoading) {
            cancelTimeout();
            setDelayedRunning(false);
            return;
        }
        if (currentTimeout.current)
            return;
        currentTimeout.current = setTimeout(() => {
            setDelayedRunning(props.isLoading);
            cancelTimeout();
        }, props.delay);
    }, [props.isLoading]);
    const cancelTimeout = () => {
        clearTimeout(currentTimeout.current);
        currentTimeout.current = undefined;
    };
    (0, react_1.useEffect)(() => {
        // on mount
        if (typeof location === "object") {
            setSvil(location.href.includes("svil") ||
                location.href.includes("coll") ||
                location.href.includes("localhost") ||
                location.href.includes("10.13.98.247"));
        }
        if (!isLoadingCalled.current) {
            throw new Error('[isLoading] is missing! Usage: <tpd-loading [isLoading]="isLoading"></tpd-loading>.');
        }
        return () => {
            // on unmount
            cancelTimeout();
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(TpdLoading_style_1.TpdLoadingContainer, Object.assign({ className: "tpd-loading-container" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `${props.fixedHeight ? 'fixedHeight' : ''}
                ${props.fixedHeightSmall ? 'fixedHeightSmall' : ''}
                ${props.marginUnibox ? 'marginUnibox' : ''}
                ${props.inlayedSpinner ? 'inLayer' : ''}` }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ "data-testid": "loading-spinner", className: `col-xs-24 tpd-loading ${props.overlayedSpinner ? 'overLayer' : ''}` }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `sk-circle ${props.fixedHeightSmall ? 'smallDiv' : ''}`, style: props.customCirleStyle }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "sk-circle1 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle2 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle3 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle4 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle5 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle6 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle7 sk-child" }), (0, jsx_runtime_1.jsx)("div", { className: "sk-circle8 sk-child" })] })) })), isSvil && props.overlayTitle && props.overlayTitle != '' && isDelayedRunning && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "loading-text", "data-testid": "loading-text" }, { children: [props.overlayTitle, "..."] })))] })) })));
};
exports.TpdLoading = TpdLoading;
exports.TpdLoading.defaultProps = {
    overlayedSpinner: false,
    inlayedSpinner: false,
    fixedHeightSmall: false,
    delay: 300
};
